module.exports = __webpack_public_path__ + "static/media/toilet-paper-alt.123b9a5d.svg";